import {UPDATE_GROWTH_PATH_ERROR, UPDATE_GROWTH_PATH_START, UPDATE_GROWTH_PATH_SUCCESS} from "../../types";

export default function update_growth_path(state, action) {
    switch (action.type) {
        case UPDATE_GROWTH_PATH_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_GROWTH_PATH_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case UPDATE_GROWTH_PATH_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
